import axios from 'axios';
import apiConfig from '../api.config';

export default function handleSuscriptionRequest({ hotelId, module, action, ownerId = null }) {
  const {
    host,
    URIs: { handleSuscription },
  } = apiConfig;

  const uri = `${host}${handleSuscription.replace(':module', module)}`;

  const data = {
    hotelId,
    action,
    ownerId,
  };

  return axios
    .post(uri, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
